export default __webpack_public_path__ + "static/media/emotional.0fb754e8.svg";